module.exports = __webpack_public_path__ + "static/media/04.80d0e6f7.svg";